import { Injectable, Inject } from '@angular/core';
import { User } from './model';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { catchError, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ProjectConfigurationService } from '../global_services/project_config.service';

import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })
export class AuthService {

    login_method = 'office365'; //'local'

    NAME_KEY = 'name';
    TOKEN_KEY = 'token';
    ROL_KEY = "role";
    redirectUrl: string = '/collection_process/quizz-take/welcome-screen';

    ID_KEY = 'id';

    clientId;
    BACKEND_URL; 
    FRONTEND_URL;
    currentToken;

    // store the URL so we can redirect after logging in
    // redirectUrl: string;

    currentUser = new BehaviorSubject(null);

    constructor( private msalService: MsalService,  private projectConfigurationService: ProjectConfigurationService, @Inject('BACKEND_URL') BACKEND_URL, @Inject('FRONTEND_URL') FRONTEND_URL, private http: HttpClient, private router: Router, private matSnack: MatSnackBar) {
        this.BACKEND_URL = BACKEND_URL;
        this.FRONTEND_URL = FRONTEND_URL;
    }

    get username() {
        if (this.currentUser.value) {
            return this.currentUser.value.username;
        }
        return null;
        //let newUserName = localStorage.getItem(this.NAME_KEY);    
        //this.setCurrentUser({name: newUserName});  
        //return localStorage.getItem(this.NAME_KEY);
    }


    get id() {
        if (this.currentUser.value) {
            return this.currentUser.value.id;
        }
        return null;

    }

    
    get distribution_unit() {
        if (this.currentUser.value) {
            return this.currentUser.value.distribution_unit;
        }
        return null;
    }

    get distribution_unit_branch_office() {
        if (this.currentUser.value) {
            return this.currentUser.value.distribution_unit_branch_office;
        }
        return null;
    }

    get room() {
        return 'SIMPLE/1'
    };

    get role() {

        if (this.currentUser.value) {
            return this.currentUser.value.role;
        }
        return null;
    };


    get recinto() {

        if (this.currentUser.value) {
            return this.currentUser.value.recinto;
        }
        return null;

    };


    get num_role() {
        return 1;
        //return localStorage.getItem(this.ROL_KEY);
    }


    public setCurrentUser(newUser: User): void {
        this.currentUser.next(newUser);
    }

    public isLoggedIn() {
        // console.log("isLoggedIn", this.projectConfigurationService.currentConfigData, this.projectConfigurationService.clientId)
        /*         if (!this.currentUser.value) {
                    this.router.navigate(["/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/login']);
                    
                    // this.router.navigate(['/']);
                } */
        return this.currentUser.value ? true : false;
    }

    public login(loginData, redirect?, selectedRole?) {
        console.log("loginData", loginData)
        loginData.customer_id = this.projectConfigurationService.currentConfigData.customer_id;

        return this.http.post<any>(this.BACKEND_URL + '/user/login', loginData).pipe(          
            map((result) => {
                console.log("result login data = ", result)
                if (!result.token) {
                    return;
                } else {
                    result.user.id = result.id; //Agregado 2024
                    result.user.role = selectedRole || result.roles[0]; // Apply selected role or default to first role
                    result.user.recinto = result.recinto;

                    this.currentUser.next(result.user);
                    localStorage.setItem("token", result.token);
                    this.currentToken = result.token;

                    console.log("result.roles = ", result.roles);

                    if (!selectedRole && result.roles.length > 1) {
                        return { result, multiRole: true };
                    }

                    console.log("user registered")
                    this.matSnack.open("Usuario registrado", "close", { duration: 2000 }); // MODIFIED /quizz-builder/list
                    var url = redirect ? redirect : ("/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/collection_process');

                    console.log("this.currentUser.value.role ", this.currentUser.value.role);

                    if(this.currentUser.value.role=='dc_admin' ){
                        url = "/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/collection_process/distribution_unit/du_panel'
                    }

                    if(this.currentUser.value.role=='examinee'){
                        url = "/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/collection_process/my_courses'
                       // url = "/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/collection_process/discover'
                    }
                    
                    if(this.currentUser.value.role=='du_admin' ){
                        url = "/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/collection_process/my_courses'
                    }

                    if(this.currentUser.value.role=='coordinador_area'){
                        url = "/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/collection_process/my_courses/'
                    }

                    if(this.currentUser.value.role=='coordinador' || this.currentUser.value.role=='coordinador_carrera' || this.currentUser.value.role=='director' || this.currentUser.value.role=='decana_grado' ){
                        url = "/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/collection_process/my_courses/'
                    }

                    if(this.currentUser.value.role=='coordinador_postgrado' ||  this.currentUser.value.role=='encargado_postgrado' || this.currentUser.value.role=='encargado_programa_postgrado'){
                        url = "/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/collection_process/quizz-builder/list'
                    }

                    console.log("login service->redirecting to", url);
                    this.router.navigate([url]);

                    //this.router.navigate([url], { queryParams: {redirect: url, client: this.projectConfigurationService.currentConfigData.instance_name}} );
                    return result;
                }
            }),
            catchError(this.handleError("No fue posible ingresar al sistema.", undefined))
        )

    }

    public registerUser(user, login?) {
        console.log("registerUser ", user);

        delete user.confirm_password;
        user.customer_id = this.projectConfigurationService.currentConfigData.customer_id;
        if (!login) user.userAdministrator = this.username ? this.username : null;
        return this.http.post<any>(this.BACKEND_URL + '/user/create', user).pipe(
            map((result) => {

                console.log("result  ", result);
                if (!result.token) {
                    return;
                } else {
                    if (login == true) {
                        localStorage.setItem("token", result.token);
                        this.setCurrentUser(result.user)
                    }
                    this.matSnack.open("Usuario registrado", "close", {  duration: 2000 });
                    return result;
                }
            }),
          /*   catchError(err => {
                console.log("error", err)
                this.matSnack.open("Error: " + err.error + ", y que está conectado.", 'cerrar', {  panelClass: 'snackbar', duration: 3000 });
                throw 'No se pudo crear el usuario';
            }) */
        )

    }

    public manage_user(username) {
        var body = { customer_id: this.projectConfigurationService.currentConfigData.customer_id, administrator: this.username, username }
        return this.http.post<any>(this.BACKEND_URL + '/user/manage', body).pipe(
            map((result) => {
                if (result) {
                    this.matSnack.open("Usuario asignado", "close", { duration: 2000 });
                    return result;
                }
            }),
            catchError(this.handleError("No fue posible asignar el usuario", undefined))
        )

    }

    gen_google_user_token(userId) {
        var body = { customer_id: this.projectConfigurationService.currentConfigData.customer_id, userId: userId }
        return this.http.post<any>(this.BACKEND_URL + '/user/gen_google_user_token', body).pipe(
            map((result) => {
                if (result) {
                    //  this.matSnack.open("Usuario asignado", "close", { duration: 2000 });
                    return result;
                }
            }),
            catchError(this.handleError("No fue posible obtener token", undefined))
        )

    }

    public logout() {
        if(this.login_method == 'office365' && this.role == 'examinee'){            
            this.msalService.logout().subscribe(x => {
                console.log("LOGOUT!!!");
                this.currentUser.next(undefined);
                localStorage.removeItem("token");
                this.router.navigate(["/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/login']);
            });
        }
        else{
            this.currentUser.next(undefined);
            localStorage.removeItem("token");
            this.router.navigate(["/" + (this.projectConfigurationService.currentConfigData.instance_name) + '/login']);
        }
 
    }

    emailForgotPassword(loginData) {
        var body = { customer_id: this.projectConfigurationService.currentConfigData.customer_id, username: loginData.username, url: this.FRONTEND_URL + '/password-reset/' + this.projectConfigurationService.currentConfigData.instance_name + '/' }
        return this.http.post<any>(this.BACKEND_URL + '/user/forgot-password', body).pipe(
            map((result) => {
                if (result) {
                    // this.matSnack.open("Correo enviado", "close", { duration: 2000 });
                    return result;
                }
            }),
            catchError(err => {
                console.log("error", err)
                this.matSnack.open("No fue posible enviar al correo, verifique el usuario.", 'cerrar', { duration: 3000 });
                throw 'No se pudo enviar el correo';
            })
        )

    }



    /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // If there is not more items to administer

            // TODO: send the error to remote logging infrastructure
            console.error("Error:", + operation, error); // log to console instead
            if (error.status == 0 || error.status == 500) {
                this.matSnack.open("Servidor desconectado", 'cerrar',
                    { duration: 6000, panelClass: ['error_snack'] })

            } else {
                this.matSnack.open("Error: " + operation + " " + error.error, 'cerrar',
                    { panelClass: ['error_snack'] })

            }


            // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.

            return of(result as T);
        };
    }



}